import { api } from "./api";

const sent = new Set();
let queue = [];
let timer = null;

const flush = () => {
    const events = queue;
    queue = [];
    timer = null;
    if (events.length) api.post("/spotlight/stats", { events }).catch(() => {});
};

const enqueue = (e, delay) => {
    queue.push(e);
    if (!timer) timer = setTimeout(flush, delay);
};

export const adImpression = (type, itemId) => {
    if (!itemId) return;
    const key = `${type}:${itemId}`;
    if (sent.has(key)) return;
    sent.add(key);
    enqueue({ type, item_id: itemId, event: "impression" }, 1500);
};

export const adClick = (type, itemId) => {
    if (!itemId) return;
    enqueue({ type, item_id: itemId, event: "click" }, 300);
};
